/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import CardSplash from '_components/Card/CardSplash';
import PatientLoginForm from '_containers/Form/PatientLoginForm';
import MainLayout from '_containers/Layout/MainLayout';
import { URL_HIN_LOGIN, URL_FORGOT_PASSWORD } from '_constants/urls';
import Logo from '_assets/imgs/eams_logo.svg';
import './styles.scss';

const componentBaseClass = 'qoc-patient-login-page';
const title = <h1 style={{ fontWeight: 'bold' }}>Welcome to the eAMS!</h1>;

function LoginPage() {
  return (
    <div className={componentBaseClass}>
      <MainLayout>
        <div className={`${componentBaseClass}__content row`}>
          <div className="d-none d-sm-none d-md-block col-md-6">
            <div className={`${componentBaseClass}__columns`}>
              <img
                src={Logo}
                alt="logo"
                className={`${componentBaseClass}__logo`}
              />
            </div>
          </div>
          <div className={`${componentBaseClass}__columns col-md-6 col-xs-12`}>
            <div style={{ width: '75%' }}>
              <CardSplash title={title}>
                <div>
                  The Electronic Asthma Management System (eAMS) has changed to
                  an email/password log in system. If you signed up using Health
                  Card Number and Date of Birth, click{' '}
                  <Link
                    className={`${componentBaseClass}__privacy-policy`}
                    to={{
                      pathname: URL_HIN_LOGIN
                    }}
                  >
                    here
                  </Link>
                  .
                </div>
                <PatientLoginForm />
                <div className={`${componentBaseClass}__links`}>
                  <Link
                    className={`${componentBaseClass}__privacy-policy`}
                    to={{
                      pathname: URL_FORGOT_PASSWORD
                    }}
                  >
                    Forgot Password?
                  </Link>
                  <Link
                    className={`${componentBaseClass}__privacy-policy`}
                    to={{
                      pathname: URL_HIN_LOGIN
                    }}
                  >
                    New User? Sign Up
                  </Link>
                </div>
              </CardSplash>
              <div className={`${componentBaseClass}__footer`}>
                <div className={`${componentBaseClass}__privacy-policy`}>
                  <a
                    href="http://easthma.ca/privacy_policy.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
}

LoginPage.propTypes = {};
LoginPage.defaultProps = {};

export default LoginPage;
